export default "__VITE_ASSET__B8gz87kM__"